export default __webpack_public_path__ + "static/media/BioApp_Logo_White.89ca26e8.svg";